import { JobInformation } from './JobInformation';
import { ReceivingContacts } from './ReceivingContacts';
import { FetchedPoValues } from './FetchedPoValues';
import { FormattedContacts } from './FormattedContacts';
import { LocationInformation } from './LocationInformation';
import { PoLineItem } from './PoLineItem';
import { ReceivingStatus } from './ReceivingStatus';

export class FormattedPoValues {
  public constructor(init?: Partial<FetchedPoValues>) {
    Object.assign(this, {
      jobInformation: init?.jobInformation,
      locationInformation: new LocationInformation(init?.locationInformation),
      contactInformation: new FormattedContacts(
        init?.contactInformation,
        init?.contactInsights,
      ),
      lineItems: init?.lineItems ?? [],
      poExternalNotes: init?.poExternalNotes
        ? init?.poExternalNotes.replace(
            /\n(?=Received on \d{2}\/\d{2}\/\d{2})/g,
            '\n\n',
          )
        : '',
      receivingStatus: init?.receivingStatus ?? null,
      errorMessages: init?.errorMessages ?? null,
    });
  }
  jobInformation: JobInformation = new JobInformation();
  contactInformation: FormattedContacts = new FormattedContacts();
  locationInformation: LocationInformation = new LocationInformation();

  /** The PO's line items — ordered data plus the per-line receiving rollup. */
  lineItems: PoLineItem[] = [];

  /** PO-level external notes from the ERP (long free-text); '' when the PO has none. */
  poExternalNotes: string = '';

  /** PO-level receiving status; `null` if the ledger read soft-failed (see `errorMessages`). */
  receivingStatus: ReceivingStatus | null = null;

  /** Non-null if a sub-fetch soft-failed; the request still returns 200. */
  errorMessages: string | null = null;
}
